
<div class="autoridades-card" [class.modal-mode]="modal" *ngIf="autoridadesLista && autoridadesLista.length > 0">
  <div *ngIf="modal" class="autoridades-header" [style.background-color]="color">
    <h2 class="quicksand-bold">AUTORIDADES</h2>
  </div>
  <div *ngIf="!modal"  class=" title-card " [style.background-color]="color">
      <h3 class="quicksand-bold">AUTORIDADES</h3>
  </div>
  <div class="autoridades-body"  [style.width]="(modal) ? '100%' : '90%'" >
    
    <!-- NO MODAL DESK/MOB-->
    <div class="container-autoridad-principal "  *ngIf="!modal">
      <div class="autoridad-principal" *ngIf="autoridadPrincipal">
      <img 
        [src]="autoridadPrincipal.path || 'assets/img/default.png'" 
        (error)="fallbackFoto($event)" 
        class="foto-autoridad large" 
        alt="Foto Principal"
      />
           <h3 class="nombre nunito-bold">{{ autoridadPrincipal.name || '-' }}</h3>
           <h4 class="puesto nunito-medium">{{ autoridadPrincipal.authorityJob?.title || '-' }}</h4>
           <p class="texto nunito-medium">{{ autoridadPrincipal.place || '-' }}</p>
        
    </div>
    </div>
    <div class="carrusel-wrapper" *ngIf="!modal &&  restoAutoridades.length > 0">
      <button class="btn-flecha prev" *ngIf="canScrollLeft" (click)="scrollHorizontal(slider, -1)" type="button">
        <img src="assets/img/arrow-carrousel2-left.png" alt="Siguiente">
      </button>
      <div class="autoridades-grid-2-filas" #slider (scroll)="checkScroll()">
        <div class="autoridad-item" *ngFor="let item of restoAutoridades">

         <hr class="mob divider" [style.color]="color" style="height: 1px;width: 100%;margin: 20px 0px!important;">
           <div class="info-autoridad">
             <img 
            [src]="item.path || 'assets/img/default.png'" 
            (error)="fallbackFoto($event)" 
            class="foto-autoridad small" 
            alt="Foto Autoridad"
          />
          <div clas="datos-autoridad">
            <h3 class="nombre-sm nunito-bold">{{ item.name || '-' }}</h3>
            <h4 class="puesto-sm nunito-medium">{{ item.authorityJob?.title || '-' }}</h4>
            <p class="texto-sm nunito-medium">{{ item.place || '-' }}</p>
          </div>
           </div>
        
        </div>
      </div>

    <button  class="btn-flecha next"  *ngIf="canScrollRight"  (click)="scrollHorizontal(slider, 1)"  type="button">
        <img src="assets/img/arrow-carrousel2-right.png" alt="Siguiente">
    </button>

    </div>


    <!-- MODAL DESK-->
      <div class="container-autoridad-principal desk "  *ngIf="modal">
      <div class="autoridad-principal" *ngIf="autoridadPrincipal">
      <img 
        [src]="autoridadPrincipal.path || 'assets/img/default.png'" 
        (error)="fallbackFoto($event)" 
        class="foto-autoridad large" 
        alt="Foto Principal"
      />
           <h3 class="nombre nunito-bold">{{ autoridadPrincipal.name || '-' }}</h3>
           <h4 class="puesto nunito-medium">{{ autoridadPrincipal.authorityJob?.title || '-' }}</h4>
           <p class="texto nunito-medium">{{ autoridadPrincipal.place || '-' }}</p>
        
    </div>
    </div>
    <div class="carrusel-wrapper desk" *ngIf="modal &&  restoAutoridades.length > 0">
      <button class="btn-flecha prev" *ngIf="canScrollLeft" (click)="scrollHorizontal(slider, -1)" type="button">
        <img src="assets/img/arrow-carrousel2-left.png" alt="Siguiente">
      </button>
      <div class="autoridades-grid-2-filas" #slider (scroll)="checkScroll()">
        <div class="autoridad-item" *ngFor="let item of restoAutoridades">

         <hr class="mob divider" [style.color]="color" style="height: 1px;width: 100%;margin: 20px 0px!important;">
           <div class="info-autoridad">
             <img 
            [src]="item.path || 'assets/img/default.png'" 
            (error)="fallbackFoto($event)" 
            class="foto-autoridad small" 
            alt="Foto Autoridad"
          />
          <div clas="datos-autoridad">
            <h3 class="nombre-sm nunito-bold">{{ item.name || '-' }}</h3>
            <h4 class="puesto-sm nunito-medium">{{ item.authorityJob?.title || '-' }}</h4>
            <p class="texto-sm nunito-medium">{{ item.place || '-' }}</p>
          </div>
           </div>
        
        </div>
      </div>

    <button  class="btn-flecha next"  *ngIf="canScrollRight"  (click)="scrollHorizontal(slider, 1)"  type="button">
        <img src="assets/img/arrow-carrousel2-right.png" alt="Siguiente">
    </button>

    </div>

    <!-- MODAL MOB-->

    <div class="container-autoridad-principal modal-content-mob" *ngIf="modal">
      <div class="autoridad-principal" *ngIf="autoridadPrincipal">
      <img 
        [src]="autoridadPrincipal.path || 'assets/img/default.png'" 
        (error)="fallbackFoto($event)" 
        class="foto-autoridad small" 
        alt="Foto Principal"
      />
       <div class="info-autoridad-principal">
        <h3 class="nombre nunito-bold">{{ autoridadPrincipal.name || '-' }}</h3>
        <h4 class="puesto nunito-medium">{{ autoridadPrincipal.authorityJob?.title || '-' }}</h4>
        </div>
    </div>
    </div>
    <div class="container-mob " *ngIf="modal && restoAutoridades.length > 0">
    
      <!-- Grid con las demás autoridades -->
      <div style="width: 100%;">
        <div class="autoridad-item" *ngFor="let item of restoAutoridades">
         <hr class="mob divider" [style.color]="color" style="height: 1px;width: 100%;">
           <div class="info-autoridad">
          <div clas="datos-autoridad">
            <h3 class="nombre-sm nunito-bold">{{ item.name || '-' }}</h3>
            <h4 class="puesto-sm nunito-medium">{{ item.authorityJob?.title || '-' }}</h4>
           </div>
           </div>
        
        </div>
      </div>

   
    </div>
  </div>

  <div class="autoridades-footer" [style.background-color]="color"></div>

</div>
